import { createSelector } from 'reselect';
import { applicationPropertiesSelector as propertiesSelector } from './properties';

export const applicationFeatureDiscoverySelector = createSelector(
  [propertiesSelector],
  // eslint-disable-next-line no-bitwise
  ({ featureDiscovery }) => (featureId) => !!(featureDiscovery & featureId),
);
